import EventEmitter from "@folio-2026/shared/eventemitter"

import { sm } from "../../shared/const/mq"
import { useExperienceStore } from "./store"

export default class Sizes extends EventEmitter {
  width: number = 0
  height: number = 0
  pixelRatio: number = 0
  isMobile: boolean = false

  private resizeThrottleId: number | null = null
  private resizeTimeoutId: number | null = null
  private readonly throttleTime: number = 300 // ms
  private resizeObserver: ResizeObserver | null = null
  private element: HTMLElement

  constructor() {
    super()

    const element = document.getElementById("app-height-checker")

    if (!element) {
      throw new Error("App height checker element not found")
    }

    this.element = element

    this.setSize()

    this.resizeObserver = new ResizeObserver(this.throttledResize.bind(this))
    this.resizeObserver.observe(this.element)
  }

  setSize() {
    const newWidth = this.element.clientWidth
    const newHeight = this.element.clientHeight

    if (newWidth === this.width && newHeight === this.height) {
      return
    }

    console.log(
      "%cResize detected",
      "color: orange; font-weight: bold",
      this.element.clientWidth,
      this.element.clientHeight,
    )

    this.width = newWidth
    this.height = newHeight

    this.isMobile = this.width < sm

    this.pixelRatio = Math.min(window.devicePixelRatio, 2)

    useExperienceStore.setState((state) => ({
      ...state,
      width: this.width,
      height: this.height,
      pixelRatio: this.pixelRatio,
    }))
  }

  private throttledResize() {
    // Clear any existing timeout
    if (this.resizeTimeoutId !== null) {
      clearTimeout(this.resizeTimeoutId)
    }

    // Set a new timeout
    this.resizeTimeoutId = window.setTimeout(() => {
      // Only proceed if no animation frame is already scheduled
      if (this.resizeThrottleId !== null) {
        return
      }

      this.resizeThrottleId = window.requestAnimationFrame(() => {
        this.setSize()
        this.trigger("resize")
        this.resizeThrottleId = null
      })
    }, this.throttleTime)
  }
}
